import styled from 'styled-components';
import { boxShadow } from 'js/config/style';
import AnimatedBox from 'js/components/core/SteppedPage/AnimatedBox';

export default styled(AnimatedBox)`
  background: white;
  box-shadow: ${boxShadow};
`;
